import React from "react";
import { NavLink } from "react-router-dom";
import { useLsp } from "../store/LspContext";

const linkStyle = ({ isActive }) => ({
    padding: "8px 10px",
    borderRadius: 10,
    textDecoration: "none",
    color: isActive ? "#fff" : "black",
    background: isActive ? "#334155" : "transparent",
});

export default function TopNav() {
    const { state, setBaseUrl, setUsername, setPassword, setToken, setPartnerLoanId, reset } = useLsp();

    return (
        <div style={{ background: "#fffff", color: "#e5e7eb", padding: 12, borderBottom: "1px solid #334155" }}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
                <strong style={{ marginRight: 10 }}>LSP Tester</strong>

                <input
                    style={inpWide}
                    value={state.baseUrl}
                    onChange={(e) => setBaseUrl(e.target.value)}
                    placeholder="Base URL"
                />
                <input style={inp} value={state.username} onChange={(e) => setUsername(e.target.value)} placeholder="username" />
                <input style={inp} value={state.password} onChange={(e) => setPassword(e.target.value)} placeholder="password" type="password" />
                <input style={inpWide} value={state.token} onChange={(e) => setToken(e.target.value)} placeholder="Bearer token" />
                <input style={inp} value={state.partnerLoanId} onChange={(e) => setPartnerLoanId(e.target.value)} placeholder="partner_loan_id" />

                <button style={btn} onClick={reset}>Reset</button>
            </div>

            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 10 }}>
                <NavLink to="/" style={linkStyle}>Home</NavLink>
                <NavLink to="/token" style={linkStyle}>1 Token</NavLink>
                <NavLink to="/create-loan" style={linkStyle}>2 Create Loan</NavLink>
                <NavLink to="/loan-status" style={linkStyle}>3 Loan Status</NavLink>
                <NavLink to="/repayment-schedule" style={linkStyle}>4 Repayment Schedule</NavLink>
                <NavLink to="/initiate-nach" style={linkStyle}>5 Initiate NACH</NavLink>
                <NavLink to="/create-agreement" style={linkStyle}>6 Create Agreement</NavLink>
                <NavLink to="/loan-details" style={linkStyle}>7 Loan Details</NavLink>
                <NavLink to="/upload-docs" style={linkStyle}>8 Upload Docs</NavLink>
                <NavLink to="/retrieve-docs" style={linkStyle}>9 Retrieve Docs</NavLink>
                <NavLink to="/view-agreement" style={linkStyle}>10 View Agreement</NavLink>
                <NavLink to="/initiate-upi" style={linkStyle}>11 Initiate UPI</NavLink>
                <NavLink to="/get-payment" style={linkStyle}>12 Get Payment(s)</NavLink>
            </div>
        </div>
    );
}

const inp = {
    padding: 8, borderRadius: 10, border: "1px solid #334155", background: "#0f172a", color: "#e5e7eb", width: 170
};
const inpWide = { ...inp, width: 320 };
const btn = {
    padding: "8px 12px", borderRadius: 10, border: "1px solid #475569", background: "#1f2937", color: "#e5e7eb", cursor: "pointer"
};
